module.exports = __webpack_public_path__ + "img/services3.83cbd4b9.png";